import type { Locale } from '@/config/build/index.js';

export const DEVELOPMENT_URLS = new Map<Locale, string>([
  ['br', 'https://local.integration.notes.br.noa.ai'],
  ['de', 'https://local.integration.notes.de.noa.ai'],
  ['es', 'https://local.integration.notes.es.noa.ai'],
  ['it', 'https://local.integration.notes.it.noa.ai'],
  ['mx', 'https://local.integration.notes.mx.noa.ai'],
  ['pl', 'https://local.integration.notes.pl.noa.ai'],
  ['tr', 'https://local.integration.notes.tr.noa.ai'],
]);

export const PRODUCTION_URLS = new Map<Locale, string>([
  ['br', 'https://integration.notes.br.noa.ai'],
  ['de', 'https://integration.notes.de.noa.ai'],
  ['es', 'https://integration.notes.es.noa.ai'],
  ['it', 'https://integration.notes.it.noa.ai'],
  ['mx', 'https://integration.notes.mx.noa.ai'],
  ['pl', 'https://integration.notes.pl.noa.ai'],
  ['tr', 'https://integration.notes.tr.noa.ai'],
  ['ar', 'https://integration.notes.ar.noa.ai'],
  ['cl', 'https://integration.notes.cl.noa.ai'],
  ['co', 'https://integration.notes.co.noa.ai'],
  ['pe', 'https://integration.notes.pe.noa.ai'],
  ['cz', 'https://integration.notes.cz.noa.ai'],
  ['pt', 'https://integration.notes.pt.noa.ai'],
  ['eu-sandbox', 'https://integration.notes.sandbox-europe.noa.ai'],
  ['sa-sandbox', 'https://integration.notes.sandbox-southamerica.noa.ai'],
  ['na-sandbox', 'https://integration.notes.sandbox-northamerica.noa.ai'],
]);

export const getTestingUrl = (testingName: string) =>
  `https://tenant1.${testingName}.noa-notes-integration.tst.docplanner.com`;
